import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';


const ProtectedRoute = ({ children }) => {
    const { isLoggedIn, isAuthChecking } = useAuth();

    if (isAuthChecking) {
        return (
            <div style={{
                width: '100dvw', height: '100dvh',
                background: '#000000',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontFamily: 'Pretendard', fontSize: '14px', color: '#555555',
            }}>
                불러오는 중...
            </div>
        );
    }

    if (!isLoggedIn) {
        return <Navigate to="/auth/login" replace />;
    }

    return children;
};

export default ProtectedRoute;
